import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterServers",
  pure: false
})
export class FilterServers implements PipeTransform {
  transform(list: any[], filters: object): any[] {
    let listValues = list;

    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        const values = filters[key];
        if (values.length > 0) {
          listValues = listValues.filter(item => {
            return values.indexOf(item[key]) > -1;
          });
        }
      }
    }

    return listValues;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-servers.pipe.ts